import moment from 'moment'
import { getValidationCheck, replaceByKeyValue, returnUnique } from '../helpers'

// import { getItemByKeyValue } from '../helpers'

import {
  CampaignCodesCompressed,
  CampaignCodeGeneratorStructure,
} from '../api-client/api-types'

export interface CampaignCodesState {
  validatedUrls: any
  metricsList: string[]
  codes: CampaignCodesCompressed[]
  loadingStatus: boolean
  loadingUsersCodesStatus: boolean
  usersCodes: CampaignCodesCompressed[]
  generatedStructure: CampaignCodeGeneratorStructure | null
  batchCodesTotal: number
  batchCodes: any[]
  batchUsersCodes: any[]
  ftpDetails: FTPDetails
  recentlyValidatedUrls: any
  shortLinkIdList: string[]
}

export const initialState = {
  shortLinkIdList: [],
  recentlyValidatedUrls: {},
  validatedUrls: {},
  metricsList: [],
  codes: [],
  loadingStatus: false,
  usersCodes: [],
  loadingUsersCodesStatus: true,
  generatedStructure: null,
  batchCodes: [],
  batchUsersCodes: [],
  batchCodesTotal: 0,
  ftpDetails: {
    adobeFTPHost: '',
    adobeFTPLogin: '',
    adobeFTPPassword: '',
    relationID: '',
    reportID: '',
  },
}

export const campaignCodes = (
  state: CampaignCodesState = initialState,
  action: ReduxAction,
): CampaignCodesState => {
  switch (action.type) {
    case 'ADD_SHORT_LINK_ID': {
      const useLinks = returnUnique([
        ...state.shortLinkIdList,
        ...action.payload,
      ])
      return {
        ...state,
        shortLinkIdList: [...useLinks],
      }
    }
    case 'REMOVE_SHORT_LINK_ID': {
      const useLinks = state.shortLinkIdList.filter((item) => {
        return action.payload.indexOf(item) === -1
      })
      return {
        ...state,
        shortLinkIdList: useLinks,
      }
    }
    case 'GET_MIN_CAMPAIGN_CODES': {
      const {
        codeID,
        author,
        createdTime,
        shortLink,
        codeDef,
        minGenDef,
        fullLink,
      } = action.payload
      const transformedCodes: CampaignCodesCompressed[] = []
      codeID.forEach((cID, index) => {
        const t = moment.unix(createdTime[index]).format()
        const cDef = minGenDef.map(({ paramID: fID }, minGenDefIndex) => {
          // paramName: v
          return {
            fID,
            n: codeDef[index][minGenDefIndex],
          }
        })
        const code = {
          c: fullLink[index],
          cDef,
          t,
          cID,
          e: author[index],
          sL: shortLink[index],
        }
        transformedCodes.push(code)
      })
      return {
        ...state,
        codes: [...transformedCodes],
        loadingStatus: false,
      }
    }
    case 'GET_CAMPAIGN_CODES':
      return {
        ...state,
        codes: action.payload,
        loadingStatus: false,
      }
    case 'GET_VALIDATED_URLS':
      return {
        ...state,
        validatedUrls: action.payload,
      }

    case 'START_RECENTLY_VALIDATED_URLS': {
      const recentlyValidatedUrls = {
        ...state.recentlyValidatedUrls,
        // ...action.payload,
      }
      return {
        ...state,
        recentlyValidatedUrls,
      }
    }
    case 'GET_RECENTLY_VALIDATED_URLS': {
      const validated = {}
      const { validationResults } = action.payload
      validationResults.forEach((item) => {
        const { testUrl } = item
        validated[testUrl] = {
          ...item,
        }
      })
      const recentlyValidatedUrls = {
        ...state.recentlyValidatedUrls,
        ...validated,
      }
      return {
        ...state,
        recentlyValidatedUrls,
      }
    }
    case 'SET_RECENTLY_VALIDATED_URLS_STATUS': {
      const { validationResults } = action.payload
      const validated = {}
      validationResults.forEach((item) => {
        const { testUrl, statusCode } = item
        if (
          Object.prototype.hasOwnProperty.call(
            state.recentlyValidatedUrls,
            testUrl,
          )
        ) {
          validated[testUrl] = {
            ...state.recentlyValidatedUrls[testUrl],
            statusCode,
          }
        } else {
          validated[testUrl] = {
            statusCode,
          }
        }
      })
      const recentlyValidatedUrls = {
        ...state.recentlyValidatedUrls,
        ...validated,
      }
      return {
        ...state,
        recentlyValidatedUrls,
      }
    }
    case 'START_LOADING_CAMPAIGN_CODES':
      return {
        ...state,
        loadingStatus: true,
      }
    case 'FINISH_LOADING_CAMPAIGN_CODES':
      return {
        ...state,
        loadingStatus: false,
      }
    case 'UPDATE_CAMPAIGN_CODE':
      // Update campaign code in memory only so it doesn't have to reload the data
      return {
        ...state,
        codes: state.codes.map((code) => {
          if (action.payload.cID === code.cID) {
            return action.payload
          }
          return code
        }),
      }

    case 'DELETE_CAMPAIGN_CODES': {
      const cID = action.payload
      const filtered = state.codes.filter((code) => {
        const toDelete = !!(cID.indexOf(code.cID) !== -1)
        return !toDelete
      })
      const usersCodesFiltered = state.usersCodes.filter((code) => {
        const toDelete = !!(cID.indexOf(code.cID) !== -1)
        return !toDelete
      })
      // Update campaign code in memmory only so it doesn't have to reload the data
      return {
        ...state,
        codes: filtered,
        usersCodes: usersCodesFiltered,
        batchCodesTotal: filtered.length,
      }
    }
    case 'GET_BATCH_USERS_CAMPAIGN_CODES':
      return {
        ...state,
        batchUsersCodes: action.payload,
      }
    case 'GET_BATCH_QUERY': {
      const codes = [...state.codes, ...action.payload]
      return {
        ...state,
        codes,
        loadingStatus: state.batchCodesTotal !== codes.length,
      }
    }
    case 'EMPTY_USERS_CAMPAIGN_CODES':
      return {
        ...state,
        usersCodes: [],
        loadingUsersCodesStatus: false,
      }
    case 'GET_USERS_CAMPAIGN_CODES':
      return {
        ...state,
        usersCodes: action.payload,
        loadingUsersCodesStatus: false,
      }
    case 'PREPEND_USERS_CAMPAIGN_CODES': {
      return {
        ...state,
        usersCodes: [...action.payload, ...state.usersCodes],
        loadingUsersCodesStatus: false,
      }
    }
    case 'UPDATE_CAMPAIGN_CODE_GENERATOR_SELECT': {
      const { fieldID, selectFields: updatedSelectFields } = action.payload
      const { generatedStructure } = state
      if (generatedStructure) {
        const { paramDefs } = generatedStructure
        return {
          ...state,
          generatedStructure: {
            ...generatedStructure,
            paramDefs: paramDefs.map((item) => {
              const { selectFields } = item
              if (
                item.fieldID === fieldID &&
                selectFields &&
                updatedSelectFields
              ) {
                return {
                  ...item,
                  selectFields: [...updatedSelectFields],
                }
              }
              return item
            }),
          },
        }
      }
      return {
        ...state,
      }
    }

    case 'UPDATE_CAMPAIGN_CODE_GENERATOR_SELECT_ADD': {
      const { fieldID, newOption } = action.payload
      const { generatedStructure } = state
      if (generatedStructure) {
        const { paramDefs } = generatedStructure
        return {
          ...state,
          generatedStructure: {
            ...generatedStructure,
            paramDefs: paramDefs.map((item) => {
              const { selectFields } = item
              if (item.fieldID === fieldID && selectFields) {
                return {
                  ...item,
                  selectFields: [...selectFields, newOption],
                }
              }
              return item
            }),
          },
        }
      }
      return {
        ...state,
      }
    }

    case 'UPDATE_CAMPAIGN_CODE_GENERATOR_SELECT_UPDATE': {
      const { fieldID, updatedOption } = action.payload
      const { generatedStructure } = state
      if (generatedStructure) {
        const { paramDefs } = generatedStructure
        return {
          ...state,
          generatedStructure: {
            ...generatedStructure,
            paramDefs: paramDefs.map((item) => {
              const { selectFields } = item
              if (item.fieldID === fieldID && selectFields) {
                return {
                  ...item,
                  selectFields: selectFields.map((field) => {
                    if (updatedOption.optionID === field.optionID) {
                      return {
                        ...field,
                        ...updatedOption,
                      }
                    }
                    return field
                  }),
                }
              }
              return item
            }),
          },
        }
      }

      return {
        ...state,
      }
    }
    case 'UPDATE_MASTER_SETTINGS': {
      const { validationChecks, paramSeparator, masterPrefix } = action.payload
      // const {generatedStructure} = state
      const generatedStructure = {
        paramDefs: [],
        ...state?.generatedStructure,
        paramSeparator,
        masterPrefix,
        validationChecks,
      }
      return { ...state, generatedStructure }
    }
    case 'GET_CAMPAIGN_CODE_GENERATOR': {
      const { validationChecks, paramDefs } = action.payload
      // set default values if not set
      const rsw = getValidationCheck(validationChecks, 'REPLACE_SPACES_WITH')
      const useChecks1 = replaceByKeyValue(
        validationChecks,
        'name',
        'REPLACE_SPACES_WITH',
        rsw,
      )
      const cfs = getValidationCheck(validationChecks, 'COPY_FROM_SEPARATOR')
      const useChecks = replaceByKeyValue(
        useChecks1,
        'name',
        'COPY_FROM_SEPARATOR',
        cfs,
      )
      return {
        ...state,
        generatedStructure: {
          ...action.payload,
          paramDefs: paramDefs.map((item) => {
            if (!Object.prototype.hasOwnProperty.call(item, 'copyFromField')) {
              return item
            }
            return {
              ...item,
              copyFromField: item.copyFromField.map(
                ({ copyFromID }) => copyFromID,
              ),
            }
          }),
          validationChecks: useChecks,
        },
      }
    }
    case 'GET_FTP_DETAILS': {
      const {
        adobeFTPHost,
        adobeFTPLogin,
        relationID,
        reportID,
      } = action.payload

      const ftpDetails = {
        adobeFTPHost,
        adobeFTPLogin,
        adobeFTPPassword: '',
        relationID,
        reportID,
      }
      return {
        ...state,
        ftpDetails,
      }
    }
    default:
      return state
  }
}
